import React from "react";

interface props {
  open: boolean;
  onClose: () => void;
}

//joiner "+" means the keys are pressed together, "/" means either one
const shortcuts: { keys: string[]; joiner: string; desc: string }[] = [
  { keys: ["Ctrl", "F"], joiner: "+", desc: "Search songs" },
  { keys: ["↑", "↓"], joiner: "/", desc: "Move through the results" },
  { keys: ["Enter"], joiner: "", desc: "Open the highlighted song" },
  { keys: ["Ctrl", "E"], joiner: "+", desc: "Fit the song to the screen, or undo it" },
  { keys: ["Ctrl", "C"], joiner: "+", desc: "Toggle the capo" },
  { keys: ["←", "→"], joiner: "/", desc: "Previous / next song" },
  { keys: ["?"], joiner: "", desc: "Show this help" },
  { keys: ["Esc"], joiner: "", desc: "Close the search or this help" },
];

export default function HelpOverlay({ open, onClose }: props) {
  if (!open) return null;
  return (
    <div id="help-overlay" onClick={onClose}>
      <div className="card" onClick={(e) => e.stopPropagation()}>
        <div className="head">
          <h2>Keyboard shortcuts</h2>
          <span className="close" title="Close" onClick={onClose}>×</span>
        </div>
        <table>
          <tbody>
            {shortcuts.map(({ keys, joiner, desc }, i) => (
              <tr key={i}>
                <td className="keys">
                  {keys.map((k, j) => (
                    <React.Fragment key={j}>
                      {j > 0 && <span className="joiner">{joiner}</span>}
                      <kbd>{k}</kbd>
                    </React.Fragment>
                  ))}
                </td>
                <td className="desc">{desc}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="foot">
          Tip: click <b>Capo X</b> to play it open, or a chord to see its diagram.
        </div>
      </div>
    </div>
  );
}
